// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__28qsO","bigColWidth":"Table_bigColWidth__37mp_","biggerColWidth":"Table_biggerColWidth__7ra9O","row":"Table_row__2Lomd","col":"Table_col__cj7fD"};